import { useMemo as L, useRef as W, useState as Y, useEffect as b } from "react";
function K(e, t) {
  const a = e.startMs, r = e.signals.filter(
    (c) => c.signalHeader.signalType.toString() === t
  ), o = r[0]?.signalHeader?.samplingRate ?? 0;
  if (!o || r.length === 0)
    return {
      type: t,
      samplingRate: o ?? 0,
      startMs: a,
      dtMs: o ? 1e3 / o : 0,
      samples: new Float32Array(),
      physicalDimension: ""
    };
  const i = r.reduce(
    (c, S) => c + S.samples.length,
    0
  ), n = new Float32Array(i);
  let u = 0;
  for (const c of r)
    n.set(c.samples, u), u += c.samples.length;
  return {
    type: t,
    physicalDimension: r[0].signalHeader.physicalDimension,
    samplingRate: o,
    startMs: a,
    dtMs: 1e3 / o,
    samples: n
  };
}
function w(e, t, a = "p28") {
  const r = Array.from(
    new Set(
      e.flatMap(
        (i) => i.signals.map((n) => n.signalHeader.signalType.toString())
      )
    )
  );
  return {
    channels: t.map((i) => {
      const n = i.signalTypes.flatMap(
        (u) => e.flatMap((c) => K(c, u))
      );
      return { id: i.id, signals: n };
    }),
    edfInfo: e.map((i) => ({
      startMs: i.startMs,
      duration: i.duration,
      availableSignalTypes: r
    })),
    parseErrors: []
  };
}
const we = "dd.MM.yyHH.mm.ss", X = 2, j = 168, Z = 176, B = 8, Be = 8, He = 16, N = 184, U = 8, J = 236, Q = 8, ee = 244, te = 8, ae = 252, re = 4, ie = 88, oe = 80, $ = 256, G = 256, se = 16, ne = 80, le = 8, ce = 8, me = 8, ue = 8, pe = 8, Se = 8, Te = 80, H = 32, O = 2, de = new TextDecoder("utf-8"), x = (e, t, a) => {
  const r = new Uint8Array(e.buffer, e.byteOffset + t, a);
  return de.decode(r).replace(/\0/g, "");
}, fe = (e, t) => {
  const [a, r, o] = e.split(".").map(Number), [i, n, u] = t.split(".").map(Number), c = 2e3 + o;
  return new Date(c, r - 1, a, i, n, u).getTime();
}, Pe = (e) => {
  const t = x(e, j, B).replace(
    /:/g,
    "."
  ), a = x(e, Z, B).replace(
    /:/g,
    "."
  );
  return fe(t, a);
}, ge = (e) => {
  const t = x(e, N, U), a = parseInt(t, 10);
  if (isNaN(a)) throw new Error(`${t} doesn't represent HeaderSize`);
  return a;
}, Ae = (e) => {
  const t = x(e, ee, te), a = Number.parseFloat(t);
  if (isNaN(a))
    throw new Error(`${t} doesn't represent DataRecordDuration`);
  return a;
}, Me = (e) => {
  const t = x(e, ae, re), a = parseInt(t, 10);
  if (isNaN(a)) throw new Error(`${t} doesn't represent NumberOfSignals`);
  return a;
}, ye = (e) => {
  const t = x(e, J, Q), a = parseInt(t, 10);
  if (isNaN(a)) throw new Error(`${t} doesn't represent DataRecordsCount`);
  return a;
}, he = (e, t, a) => {
  const r = x(
    e,
    $,
    G * t
  ), o = [];
  for (let i = 0; i < t; i++)
    o.push(
      Ee(
        r,
        t,
        i,
        a
      )
    );
  return o;
}, Ee = (e, t, a, r) => {
  let o = 0;
  const i = (p) => {
    const M = e.substr(o + a * p, p);
    return o += t * p, M;
  }, u = i(se).trim();
  i(ne);
  const c = i(le).trim(), S = D(
    i(ce),
    "physical minimum",
    a
  ), g = D(
    i(me),
    "physical maximum",
    a
  ), f = D(
    i(ue),
    "digital minimum",
    a
  ), T = D(
    i(pe),
    "digital maximum",
    a
  );
  i(Te);
  const m = D(
    i(Se),
    "number of samples",
    a
  ), E = m / r, A = i(H).substr(
    H - O,
    O
  );
  let P = X;
  return A.startsWith("#") && (P = parseInt(A.substr(1, 1), 10)), {
    signalType: u,
    digitalMaximum: T,
    physicalMaximum: g,
    physicalMinimum: S,
    digitalMinimum: f,
    numberOfSamplesInDataRecord: m,
    samplingRate: E,
    sampleSize: P,
    physicalDimension: c
  };
}, D = (e, t, a) => {
  const r = parseFloat(e);
  if (isNaN(r))
    throw new Error(
      `Can't parse ${t} value ${e} for ${a} signal`
    );
  return r;
}, z = (e, t, a, r, o, i = !1, n = 0) => {
  const [u, c] = i ? [a + n, t + n] : [t + n, a + n], S = Math.min(Math.max(e, r), o);
  return u + (c - u) * (S - r) / (o - r);
}, Oe = (e) => e / 10;
function _e(e, t) {
  const a = new Uint8Array(e.byteLength + t.byteLength);
  return a.set(e, 0), a.set(t, e.byteLength), a;
}
async function V(e, t, a) {
  const r = await e.slice(t, a).arrayBuffer();
  return new Uint8Array(r);
}
async function* ke(e, t, a = 4 * 1024 * 1024) {
  let r = t;
  for (; r < e.size; ) {
    const o = Math.min(e.size, r + a);
    yield await V(e, r, o), r = o;
  }
}
async function F(e) {
  try {
    if (e.size === 0)
      return { isSuccess: !1, error: "File is empty" };
    const t = N + U;
    if (e.size < t)
      return {
        isSuccess: !1,
        error: "File is too small to contain a valid EDF header"
      };
    let a = await V(
      e,
      0,
      Math.min(e.size, Math.max(512, t))
    );
    const r = new DataView(a.buffer, a.byteOffset, a.byteLength), o = ge(r);
    if (o <= 0)
      return {
        isSuccess: !1,
        error: "EDF header declares invalid header size"
      };
    if (e.size < o)
      return {
        isSuccess: !1,
        error: `File is truncated: expected at least ${o} bytes for header, got ${e.size}`
      };
    a.byteLength < o && (a = await V(e, 0, o));
    const i = new DataView(a.buffer, a.byteOffset, o), n = Pe(i), u = x(
      i,
      ie,
      oe
    ).trim(), c = Ae(i), S = Me(i);
    if (c <= 0)
      return {
        isSuccess: !1,
        error: "EDF header contains invalid data record duration"
      };
    if (S <= 0)
      return { isSuccess: !1, error: "EDF header contains no signals" };
    const g = $ + G * S;
    if (o < g)
      return {
        isSuccess: !1,
        error: `EDF header is too small for ${S} signals: expected ${g} bytes, got ${o}`
      };
    const f = he(
      i,
      S,
      c
    );
    let T = ye(i);
    const m = f.reduce(
      (P, p) => P + p.numberOfSamplesInDataRecord * p.sampleSize,
      0
    );
    if (T === -1) {
      const P = e.size - o;
      T = Math.floor(P / m);
    }
    const E = new Array(S);
    let _ = 0;
    for (let P = 0; P < S; P++) {
      E[P] = _;
      const p = f[P];
      _ += p.numberOfSamplesInDataRecord * p.sampleSize;
    }
    const A = c * 1e3 * T;
    return {
      isSuccess: !0,
      header: {
        headerSize: o,
        startMs: n,
        durationMs: A,
        localRecordingIdentification: u,
        dataRecordsCount: T,
        numberOfSignals: S,
        signalHeaders: f,
        dataRecordSize: m,
        signalBlockOffsets: E
      }
    };
  } catch (t) {
    return {
      isSuccess: !1,
      error: `Failed to parse EDF file: ${t.message ?? t}`
    };
  }
}
const ve = /^[+-]?\d+$/;
async function ze(e) {
  const t = await F(e);
  return t.isSuccess ? {
    isSuccess: !0,
    data: {
      startMs: t.header.startMs,
      duration: t.header.durationMs
    }
  } : { isSuccess: !1, error: t.error };
}
async function Ne(e) {
  const t = await q(e);
  return t.isSuccess ? {
    isSuccess: !0,
    data: t.data.map(({ path: a, startMs: r, durationMs: o }) => ({
      path: a,
      startMs: r,
      durationMs: o
    }))
  } : t;
}
async function Ue(e) {
  const t = await q(e);
  return t.isSuccess ? {
    isSuccess: !0,
    data: t.data.map((a) => ({
      path: a.path,
      startMs: a.startMs,
      durationMs: a.durationMs,
      p5DeviceTimepoint: ve.test(
        a.localRecordingIdentification
      ) ? a.localRecordingIdentification : null
    }))
  } : t;
}
async function q(e) {
  const t = [];
  for (const a of e) {
    const r = await F(a.file);
    if (!r.isSuccess)
      return { isSuccess: !1, path: a.path, error: r.error };
    t.push({
      path: a.path,
      startMs: r.header.startMs,
      durationMs: r.header.durationMs,
      localRecordingIdentification: r.header.localRecordingIdentification
    });
  }
  return { isSuccess: !0, data: t };
}
async function xe(e, t = {}) {
  const a = await F(e);
  if (!a.isSuccess)
    return { isSuccess: !1, error: a.error };
  const {
    headerSize: r,
    startMs: o,
    durationMs: i,
    dataRecordsCount: n,
    numberOfSignals: u,
    signalHeaders: c,
    dataRecordSize: S,
    signalBlockOffsets: g
  } = a.header;
  try {
    const f = t.chunkSize, T = t.signalTypes ? new Set(t.signalTypes) : void 0, m = c.map(
      (p) => T ? T.has(p.signalType) : !0
    ), E = c.map((p, M) => ({
      signalHeader: p,
      samples: m[M] ? new Float32Array(p.numberOfSamplesInDataRecord * n) : new Float32Array(0)
    })), _ = new Array(u).fill(0);
    let A = new Uint8Array(0), P = 0;
    for await (const p of ke(e, r, f)) {
      const M = A.byteLength ? _e(A, p) : p, k = Math.floor(M.byteLength / S);
      if (k === 0) {
        A = M;
        continue;
      }
      const v = k * S;
      Ie(
        M.subarray(0, v),
        k,
        S,
        u,
        c,
        g,
        E,
        _,
        m
      ), P += k, t.onProgress?.({ recordsParsed: P, totalRecords: n }), A = M.subarray(v);
    }
    return {
      isSuccess: !0,
      data: {
        startMs: o,
        duration: i,
        signals: E
      }
    };
  } catch (f) {
    return {
      isSuccess: !1,
      error: `Failed to parse EDF file: ${f.message ?? f}`
    };
  }
}
function Ie(e, t, a, r, o, i, n, u, c) {
  const S = new DataView(e.buffer, e.byteOffset, e.byteLength);
  for (let g = 0; g < t; g++) {
    const f = g * a;
    for (let T = 0; T < r; T++) {
      if (!c[T]) continue;
      const m = o[T], E = m.numberOfSamplesInDataRecord, _ = m.sampleSize, A = m.signalType === "Breath Phase", P = m.signalType === "Trigger Delay";
      let p = f + i[T];
      const M = n[T].samples;
      let k = u[T];
      if (_ === 1)
        for (let v = 0; v < E; v++) {
          const R = P ? S.getInt8(p) : S.getUint8(p);
          M[k++] = z(
            R,
            m.physicalMinimum,
            m.physicalMaximum,
            m.digitalMinimum,
            m.digitalMaximum,
            A,
            A ? 1 : 0
          ), p += 1;
        }
      else if (_ === 2)
        for (let v = 0; v < E; v++) {
          const R = S.getInt16(p, !0);
          M[k++] = z(
            R,
            m.physicalMinimum,
            m.physicalMaximum,
            m.digitalMinimum,
            m.digitalMaximum
          ), p += 2;
        }
      else
        throw new Error(`Unsupported sample size: ${_}`);
      u[T] = k;
    }
  }
}
const De = { data: [], errors: [] }, Le = [];
function $e(e, t, a) {
  const r = e.generation ?? "p28", o = L(
    () => t.flatMap((u) => u.signalTypes),
    [t]
  ), i = Re(
    e.kind !== "parsed" ? e.edfFiles : Le,
    o,
    a
  ), n = L(() => e.kind === "parsed" ? w(e.signals, t, r) : w(i.data, t, r), [e, i.data, t, r]);
  return L(
    () => ({ ...n, parseErrors: i.errors }),
    [n, i.errors]
  );
}
function Re(e, t, a) {
  const r = W(a), o = t.join("|"), i = L(
    () => Symbol(),
    [e, o]
  ), [n, u] = Y({
    data: [],
    errors: []
  });
  return b(() => {
    r.current = a;
  }, [a]), b(() => {
    if (!e.length) return;
    let c = !1;
    return (async () => {
      const g = [], f = [];
      r.current?.({
        completedFiles: 0,
        totalFiles: e.length
      });
      for (const T of e) {
        const m = await xe(T, { signalTypes: t });
        if (c) return;
        m.isSuccess ? g.push(m.data) : f.push({ fileName: T.name, error: m.error }), r.current?.({
          completedFiles: g.length + f.length,
          totalFiles: e.length
        });
      }
      u({ data: g, errors: f, inputToken: i });
    })(), () => {
      c = !0;
    };
  }, [e, i, t]), n.inputToken !== i ? De : { data: n.data, errors: n.errors };
}
const y = {
  Unspecified: 0,
  DeviceType: 1,
  DevicePlatformType: 2,
  DevicePriceVariant: 3,
  DeviceVariant: 4,
  ActiveFlag: 5,
  Mode: 6,
  Pmin: 7,
  Pmax: 8,
  Pressure: 9,
  PressureMax: 10,
  PsoftMin: 11,
  Psoft: 12,
  SoftPap: 13,
  SoftPapLock: 14,
  ApapDynamic: 15,
  HumidifierLevel: 16,
  AutoStart: 17,
  SoftStartTimeMax: 18,
  SoftStartTime: 19,
  AutoDIP: 20,
  TubeType: 21,
  TubeTypeLock: 22,
  TherapyStandbyTime: 23,
  ClockChangeMode: 24,
  AutoDark: 25,
  PressureUnit: 26,
  DisplayBrightness: 27,
  BluetoothMode: 28,
  AlarmClockVolume: 29,
  AlarmClockHour: 30,
  AlarmClockMinute: 31,
  AlarmClockActive: 32,
  AlarmVolume: 33,
  AlarmLock: 34,
  AlarmLeakActive: 35,
  AlarmDisconnectionActive: 36,
  TeleConfLock: 37,
  PmaxoA: 38,
  InternalModemMode: 39,
  HumidifierState: 255
}, Ve = {
  [y.Mode]: {
    key: "Mode",
    title: "Mode"
  },
  [y.Pressure]: {
    key: "Pressure",
    title: "Pressure"
  },
  [y.PressureMax]: {
    key: "PressureMax",
    title: "Pressure max"
  },
  [y.SoftPap]: {
    key: "SoftPap",
    title: "SoftPap"
  },
  [y.SoftPapLock]: {
    key: "SoftPapLock",
    title: "SoftPap lock"
  },
  [y.ApapDynamic]: {
    key: "ApapDynamic",
    title: "APAP dynamic"
  },
  [y.HumidifierLevel]: {
    key: "HumidifierLevel",
    title: "Humidifier level"
  },
  [y.AutoStart]: {
    key: "AutoStart",
    title: "Auto start"
  },
  [y.SoftStartTimeMax]: {
    key: "SoftStartTimeMax",
    title: "SoftStart time max"
  },
  [y.SoftStartTime]: {
    key: "SoftStartTime",
    title: "SoftStart time"
  },
  [y.TubeType]: {
    key: "TubeType",
    title: "Tube type"
  }
};
function Ge(e) {
  return e in Ve;
}
const C = {
  CPAP: 1,
  APAP: 2
}, qe = C, We = {
  [C.CPAP]: "CPAP",
  [C.APAP]: "APAP"
}, Ye = {
  Off: 0,
  Empty: 1,
  Error: 4
}, l = {
  Unspecified: 0,
  NotUsed: 1,
  ModulVersion: 1001,
  Device: 1002,
  Mode: 1003,
  User: 1004,
  ActiveFlag: 1005,
  ModeNameTagAppend: 1006,
  TubeTypeLock: 1007,
  VentyFeatures: 1008,
  SetVolumeOutputToZero: 1009,
  PdiffMinIntern: 1010,
  Ti: 1011,
  Te: 1012,
  RampInTime: 1013,
  RampEx: 1014,
  WmTrackEx: 1015,
  TargetVolume: 1016,
  IpapSpeed: 1017,
  Eepap: 1018,
  AutoDiff: 1019,
  IntraBreathPressCtrl: 1020,
  IpapDelta: 1022,
  Verbose: 1023,
  HumidifierLevel: 1083,
  AutoStart: 1084,
  MaskTestPress: 1085,
  MaskTestDuration: 1086,
  AlarmVolume: 1087,
  AlarmClockVolume: 1088,
  ButtonBeepVolume: 1089,
  ExportedData: 1090,
  TubeType: 1091,
  BacteriumFilter: 1092,
  DeepStandbyAutomatic: 1093,
  DisplayedComplianceLevel: 1094,
  DisplayedCompliance: 1095,
  DisplayBrightness: 1096,
  DisplayedStandbyInfo: 1097,
  GuiFlowUnit: 1098,
  GuiPressUnit: 1099,
  GuiLangExpert: 1100,
  GuiLangPatient: 1101,
  TimeZone: 1102,
  DaylightSaving: 1103,
  AlarmClockActive: 1104,
  AlarmClockHours: 1105,
  AlarmClockMinutes: 1106,
  TwentyFourHoursClock: 1107,
  ServiceReminder: 1108,
  FilterChangeReminder: 1109,
  GuardMaintenance: 1110,
  GuardChangeFilter: 1111,
  AnalogChannel1: 1112,
  AnalogChannel2: 1113,
  AnalogChannel3: 1114,
  AnalogChannel4: 1115,
  AnalogChannel5: 1116,
  AnalogChannel6: 1117,
  AnalogChannel7: 1118,
  AnalogChannel8: 1119,
  Pmax: 1120,
  Pmin: 1121,
  CpapPress: 1122,
  SoftPapLevel: 1123,
  SoftPapFreeze: 1124,
  SoftStartPress: 1125,
  SoftStartPressMin: 1126,
  SoftStartTime: 1127,
  SoftStartTimeMax: 1128,
  ApapMin: 1130,
  ApapMax: 1131,
  EepapMin: 1138,
  EepapMax: 1139,
  PdiffNorm: 1140,
  PdiffMax: 1141,
  Delta: 1142,
  EpapMin: 1143,
  EpapMax: 1144,
  EpapMinIntern: 1146,
  IpapMinIntern: 1147,
  EpapMaxIntern: 1148,
  AbsolutPdiffMin: 1149,
  AbsolutPdiffMinTimed: 1150,
  EpapTimed: 1151,
  IpapMaxIntern: 1152,
  IpapMaxTimed: 1153,
  ExtraObstructionProtection: 1154,
  Scope: 1155,
  BackFrequAuto: 1156,
  BackGroundFrequ: 1157,
  RelativeInspirationDuration: 1158,
  SprFrequMerge: 1159,
  RampIn: 1160,
  FrequAlertLvl: 1161,
  WmTrack: 1162,
  IpapMin: 1198,
  IpapMax: 1199,
  Ipap: 1200,
  Epap: 1201,
  AlarmLeakActive: 1202,
  AlarmDisconnectionActive: 1203,
  AlarmLockedForPatient: 1204,
  CheckSum: 1205,
  AlertApneaLevel: 1206,
  AlertVtLowLevel: 1207,
  AlertAmvLowLevel: 1208,
  ApapDyn: 1209,
  HumidifierLevelMax: 1210,
  TeleSettingsAllowed: 1211,
  SoftStopTimeMax: 1212,
  SoftStopTime: 1213,
  TiMin: 1214,
  TiMax: 1215,
  TiTimed: 1216,
  HumClimaCtrl: 1217,
  AutoStop: 1218,
  AutoPdiffActive: 1219,
  SoftStartDiffRamp: 1220,
  InspToExp: 1221,
  Delta2: 1222,
  TargetFlow: 1223,
  O2Flow: 1224
}, Ce = {
  [l.Mode]: {
    key: "Mode",
    title: "Mode"
  },
  [l.EepapMin]: {
    key: "EepapMin",
    title: "EEPAP min"
  },
  [l.EepapMax]: {
    key: "EepapMax",
    title: "EEPAP max"
  },
  [l.PdiffNorm]: {
    key: "PdiffNorm",
    title: "PDIFF"
  },
  [l.PdiffMax]: {
    key: "PdiffMax",
    title: "PDIFF max"
  },
  [l.SoftPapLevel]: {
    key: "SoftPapLevel",
    title: "softPAP"
  },
  [l.ApapDyn]: {
    key: "ApapDyn",
    title: "APAP"
  },
  [l.Ipap]: {
    key: "Ipap",
    title: "IPAP"
  },
  [l.Epap]: {
    key: "Epap",
    title: "EPAP"
  },
  [l.TargetVolume]: {
    key: "TargetVolume",
    title: "Target volume"
  },
  [l.BackFrequAuto]: {
    key: "BackFrequAuto",
    title: "autoF"
  },
  [l.BackGroundFrequ]: {
    key: "BackGroundFrequ",
    title: "F min"
  },
  [l.RelativeInspirationDuration]: {
    key: "RelativeInspirationDuration",
    title: "Ti/T set"
  },
  [l.Ti]: {
    key: "Ti",
    title: "Ti"
  },
  [l.SoftStartPressMin]: {
    key: "SoftStartPressMin",
    title: "softSTART pressure"
  },
  [l.WmTrack]: {
    key: "WmTrack",
    title: "Trigger IN"
  },
  [l.WmTrackEx]: {
    key: "WmTrackEx",
    title: "Trigger EX"
  },
  [l.ExtraObstructionProtection]: {
    key: "ExtraObstructionProtection",
    title: "TRILevel"
  },
  [l.RampIn]: {
    key: "RampIn",
    title: "RAMP IN"
  },
  [l.TiMax]: {
    key: "TiMax",
    title: "Ti max"
  },
  [l.TiMin]: {
    key: "TiMin",
    title: "Ti min"
  },
  [l.TiTimed]: {
    key: "TiTimed",
    title: "Ti timed"
  },
  [l.RampEx]: {
    key: "RampEx",
    title: "RAMP EX"
  },
  [l.SoftStartTimeMax]: {
    key: "SoftStartTimeMax",
    title: "softSTART max"
  },
  [l.SoftStopTimeMax]: {
    key: "SoftStopTimeMax",
    title: "softSTOP max"
  },
  [l.SoftStartPress]: {
    key: "SoftStartPress",
    title: "softSTART pressure"
  },
  [l.AutoStart]: {
    key: "AutoStart",
    title: "autoSTART"
  },
  [l.AutoStop]: {
    key: "AutoStop",
    title: "autoSTOP"
  }
};
function Ke(e) {
  return e in Ce;
}
const d = {
  CPAP: 1,
  APAP: 2,
  ASV: 3,
  BilevelS_25: 4,
  BilevelST_25: 5,
  BilevelT_25: 6,
  AutoS: 9,
  AutoST: 10,
  BilevelS_30: 13,
  BilevelS_30V: 14,
  BilevelST_30: 15,
  BilevelST_30V: 16,
  BilevelT_30: 17,
  BilevelT_30V: 18,
  AutoST_30V: 19,
  aPCV_30: 20,
  aPCV_30V: 21,
  HFT: 22
}, Xe = {
  [d.CPAP]: "CPAP",
  [d.APAP]: "APAP",
  [d.ASV]: "AcSV",
  [d.BilevelS_25]: "S",
  [d.BilevelST_25]: "S/T",
  [d.BilevelT_25]: "T",
  [d.AutoS]: "autoS",
  [d.AutoST]: "autoS/T",
  [d.BilevelS_30]: "S (30)",
  [d.BilevelS_30V]: "S (30)",
  [d.BilevelST_30]: "S/T (30)",
  [d.BilevelST_30V]: "S/T (30)",
  [d.BilevelT_30]: "T (30)",
  [d.BilevelT_30V]: "T (30)",
  [d.AutoST_30V]: "autoS/T (30)",
  [d.aPCV_30]: "aPCV (30)",
  [d.aPCV_30V]: "aPCV (30)",
  [d.HFT]: "HFT"
}, je = [
  "mode_tmvc_CPAP",
  "mode_tmvc_APAP",
  "mode_tmvc_ASV",
  "mode_tmvc_BilevelS_25",
  "mode_tmvc_BilevelST_25",
  "mode_tmvc_BilevelT_25",
  "mode_tmvc_AutoS",
  "mode_tmvc_AutoST",
  "mode_tmvc_BilevelS_30",
  "mode_tmvc_BilevelS_30V",
  "mode_tmvc_BilevelST_30",
  "mode_tmvc_BilevelST_30V",
  "mode_tmvc_BilevelT_30",
  "mode_tmvc_BilevelT_30V",
  "mode_tmvc_AutoST_30V",
  "mode_tmvc_aPCV_30",
  "mode_tmvc_aPCV_30V",
  "mode_tmvc_HFT"
], Ze = {
  HumidifierLevel: "param_HumidifierLevel",
  SoftStartTime: "param_SoftStartTime",
  SoftStartTimeMax: "param_SoftStartTime",
  ActiveFlag: "param_ActiveFlag",
  Scope: "param_Scope",
  RampIn: "param_RampIn",
  RampEx: "param_RampEx",
  TriggerIn: "param_WmTrack",
  TriggerEx: "param_WmTrackEx",
  SoftStopTime: "param_SoftStopTime",
  SoftStopTimeMax: "param_SoftStopTimeMax"
}, h = {
  CPAP: 0,
  S: 1,
  ST: 2,
  autoST: 3,
  T: 4,
  aPCV: 5,
  PSV: 6,
  PCV: 7,
  MPVp: 8,
  MPVv: 9,
  SIMVp: 10
}, s = {
  Program: 1,
  AirTrapControl: 2,
  AlarmApnoe: 3,
  AlarmArpLimit: 4,
  AlarmFrequencyHigh: 5,
  AlarmFrequencyLow: 6,
  AlarmLeakageHigh: 7,
  AlarmMinuteVolumeHigh: 8,
  AlarmMinuteVolumeLow: 9,
  AlarmPressureHigh: 10,
  AlarmPressureLow: 11,
  AlarmPulseHigh: 12,
  AlarmPulseLow: 13,
  AlarmSpO2High: 14,
  AlarmSpO2Low: 15,
  AlarmSystemInactivation: 16,
  AlarmVolumeHigh: 18,
  AlarmVolumeLow: 19,
  AutoEPAPdeltaPinsp: 22,
  AutoEPAPmax: 23,
  AutoEPAPmin: 25,
  AutoF: 27,
  AutoStartStop: 29,
  BrightnessDisplay: 30,
  BrightnessLED: 31,
  CPAP: 32,
  EPAP: 37,
  ExhalationSystem: 38,
  ExpirationRamp: 39,
  FilterType: 40,
  Frequency: 41,
  GuiLanguage: 43,
  GuiPressureUnit: 44,
  HftFlow: 46,
  HoseType: 66,
  Humidifier: 67,
  HumidifierLevel: 68,
  IPAP: 69,
  IToE: 70,
  InspirationRamp: 74,
  LIAM: 75,
  LIAMDeltaPressure: 77,
  LIAMPressureMaximum: 81,
  LIAMTe: 82,
  LIAMTi: 83,
  PinspDelta: 84,
  PinspMax: 86,
  ProgramEnabled1: 88,
  ProgramEnabled2: 89,
  ProgramEnabled3: 90,
  Te: 91,
  Mode: 92,
  Ti: 93,
  TiMax: 94,
  TiMin: 95,
  TiTimed: 96,
  TiToT: 97,
  TriggerInspirationBlockTime: 103,
  TriggerSensitivityExspiration: 104,
  TriggerSensitivityInspiration: 105,
  TriggerType: 106,
  Volume: 107,
  VolumeAlarmExpert: 108,
  VolumeAlarmPatient: 109,
  VolumeTarget: 110,
  VolumeTargetControl: 111,
  VolumeTargetDeltaPressure: 112,
  VolumeTargetPressureMaximum: 113,
  SoftStartTime: 117,
  SoftStartTimeMax: 118,
  SoftStopTime: 119,
  SoftStopTimeMax: 120
}, Je = {
  [h.CPAP]: "CPAP",
  [h.S]: "S",
  [h.ST]: "S/T",
  [h.autoST]: "autoS/T",
  [h.T]: "T",
  [h.aPCV]: "aPCV",
  [h.PSV]: "PSV",
  [h.PCV]: "PCV",
  [h.MPVp]: "MPVp",
  [h.MPVv]: "MPVv",
  [h.SIMVp]: "SIMVp"
}, I = {
  HumidifierLevel: "HumidifierLevel",
  SoftStartTime: "sSTART_T",
  SoftStartTimeMax: "sSTART_Tmax",
  ActiveFlag: "ActiveFlag",
  Mode: "TherapyMode",
  Program: "ActiveProgram",
  RampIn: "InspirationRamp",
  RampEx: "ExpirationRamp",
  TriggerIn: "TriggerSensitivityInspiration",
  TriggerEx: "TriggerSensitivityExspiration",
  ProgramEnabled: "ProgramEnabled",
  SoftStopTime: "sSTOPP_T",
  SoftStopTimeMax: "sSTOPP_Tmax",
  ProgramPlaceholder: "ProgramPlaceholder",
  ModePlaceholder: "ModePlaceholder"
}, Fe = {
  [s.Program]: {
    key: I.Program,
    title: "Program"
  },
  [s.Mode]: {
    key: I.Mode,
    title: "Mode"
  },
  [s.ExhalationSystem]: {
    key: "ExhalationSystem",
    title: "Hose system"
  },
  [s.IPAP]: {
    key: "IPAP",
    title: "IPAP"
  },
  [s.EPAP]: {
    key: "EPAP",
    title: "EPAP"
  },
  [s.AutoEPAPmin]: {
    key: "AutoEPAPmin",
    title: "EPAPmin"
  },
  [s.AutoEPAPmax]: {
    key: "AutoEPAPmax",
    title: "EPAPmax"
  },
  [s.VolumeTarget]: {
    key: "VolumeTarget",
    title: "Target volume"
  },
  [s.VolumeTargetControl]: {
    key: "VolumeTargetControl",
    title: "Pressure adjustment"
  },
  [s.VolumeTargetDeltaPressure]: {
    key: "VolumeTargetDeltaPressure",
    title: "delta P"
  },
  [s.VolumeTargetPressureMaximum]: {
    key: "VolumeTargetPressureMaximum",
    title: "IPAP max"
  },
  [s.AirTrapControl]: {
    key: "AirTrapControl",
    title: "AirTrap Control"
  },
  [s.Frequency]: {
    key: "Frequency",
    title: "F min"
  },
  [s.TiToT]: {
    key: "Ti_to_T",
    title: "Ti/T set"
  },
  [s.IToE]: {
    key: "I_to_E",
    title: "I:E"
  },
  [s.Ti]: {
    key: "Ti",
    title: "Ti"
  },
  [s.TiMax]: {
    key: "Ti_max",
    title: "Ti max"
  },
  [s.TiMin]: {
    key: "Ti_min",
    title: "Ti min"
  },
  [s.TiTimed]: {
    key: "Ti_timed",
    title: "Ti timed"
  },
  [s.Te]: {
    key: "Te",
    title: "Te"
  },
  [s.TriggerType]: {
    key: "TriggerType",
    title: "Trigger"
  },
  [s.TriggerSensitivityInspiration]: {
    key: "TriggerSensitivityInspiration",
    title: "Trigger IN"
  },
  [s.TriggerSensitivityExspiration]: {
    key: "TriggerSensitivityExspiration",
    title: "Trigger EX"
  },
  [s.TriggerInspirationBlockTime]: {
    key: "TriggerInspirationBlockTime",
    title: "Trigger lockout time"
  },
  [s.InspirationRamp]: {
    key: "InspirationRamp",
    title: "RAMP IN"
  },
  [s.ExpirationRamp]: {
    key: "ExpirationRamp",
    title: "RAMP EX"
  },
  [s.LIAM]: {
    key: "LIAM",
    title: "LIAM (insufflation)"
  },
  [s.LIAMDeltaPressure]: {
    key: "LIAMDeltaPressure",
    title: "deltaP LIAM"
  },
  [s.LIAMPressureMaximum]: {
    key: "LIAMPressureMaximum",
    title: "IPAP LIAM"
  },
  [s.LIAMTi]: {
    key: "LIAMTi",
    title: "Ti LIAM"
  },
  [s.LIAMTe]: {
    key: "LIAMTe",
    title: "Te LIAM"
  },
  [s.SoftStartTime]: {
    key: I.SoftStartTime,
    title: "softSTART"
  },
  [s.SoftStartTimeMax]: {
    key: I.SoftStartTimeMax,
    title: "softSTART max"
  },
  [s.SoftStopTime]: {
    key: I.SoftStopTime,
    title: "softSTOP"
  },
  [s.SoftStopTimeMax]: {
    key: I.SoftStopTimeMax,
    title: "softSTOP max"
  }
};
function Qe(e, t) {
  Fe[e] = t;
}
export {
  te as DataRecordDurationLength,
  ee as DataRecordDurationOffset,
  Q as DataRecordsCountLength,
  J as DataRecordsCountOffset,
  X as DefaultEdfSampleSize,
  we as EdfDateTimeFormat,
  He as FwVersionLength,
  Be as FwVersionOffset,
  U as HeaderSizeLength,
  N as HeaderSizeOffset,
  oe as LocalRecordingIdentificationLength,
  ie as LocalRecordingIdentificationOffset,
  re as NumberOfSignalsLength,
  ae as NumberOfSignalsOffset,
  Ye as P28_HUMIDIFIER_STATE_VALUES,
  C as P28_MODE_IDS,
  We as P28_MODE_NAMES,
  qe as P28_MODE_VALUES,
  Ve as P28_PARAMETER_CATALOG,
  y as P28_PARAMETER_IDS,
  h as P32_MODE_IDS,
  Je as P32_MODE_NAMES,
  Fe as P32_PARAMETER_CATALOG,
  s as P32_PARAMETER_IDS,
  I as P32_PARAMETER_KEYS,
  d as P3_MODE_IDS,
  je as P3_MODE_KEYS,
  Xe as P3_MODE_NAMES,
  Ce as P3_PARAMETER_CATALOG,
  l as P3_PARAMETER_IDS,
  Ze as P3_PARAMETER_KEYS,
  pe as SignalDigitalMaximumLength,
  ue as SignalDigitalMinimumLength,
  G as SignalHeaderLength,
  se as SignalLabelLength,
  Se as SignalNumberOfSamplesInDataRecordLength,
  le as SignalPhysicalDimensionLength,
  me as SignalPhysicalMaximumLength,
  ce as SignalPhysicalMinimumLength,
  Te as SignalPrefilteringLength,
  H as SignalReservedLength,
  O as SignalSampleSizeLength,
  ne as SignalTransducerLength,
  $ as SignalsHeadersOffset,
  j as StartDateOffset,
  B as StartFieldLength,
  Z as StartTimeOffset,
  z as convertDigitalToPhysical,
  Ne as createEdfManifest,
  Ue as createP5EdfManifest,
  ze as getEdfHeaderInfo,
  xe as getEdfRecordChunked,
  Oe as getTimeFromStorageToSeconds,
  Ge as isP28CatalogParameterId,
  Ke as isP3CatalogParameterId,
  fe as parseEdfDateMs,
  Qe as registerP32Parameter,
  $e as usePrepareTherapyData
};
//# sourceMappingURL=index.js.map
